import React from 'react';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Footer from './pages/Footer/Footer';
import Project from './pages/Project/Project';
import HowWeWork from './pages/HowWeWork/HowWeWork';
import WhyChooseUs from './pages/WhyChooseUs/WhyChooseUs';
import Navbar from './Navbar';
import Customer from './pages/Customer/Customer';
import Contact from './pages/Contatct/contact';
import OutTeam from './pages/OurTeam /OutTeam';
import './responsive.css';
import './section-themes.css';

const Main = () => {
  return (
    <div className="main-container">
      <Navbar />
      <Home />
      <About />
      <Services />
      <Project />
      <HowWeWork />
      <WhyChooseUs />
      <Customer />
      <OutTeam />
      <Contact />
      <Footer />
    </div>
  );
};

export default Main;
